import React from 'react';
import PropTypes from 'prop-types';
import RichText from '../../../molecules/RichText';

export default function RichTextBlock({ block }) {
  return <RichText body={block.body} />;
}

RichTextBlock.defaultProps = {
  block: {
    body: null,
  },
};

RichTextBlock.propTypes = {
  block: PropTypes.shape({
    body: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};
